export { default } from "./noContentView";
